import VMasker from 'vanilla-masker';
import React from 'react';
import * as UI from 'material-ui';

class MaskedTextField extends React.Component {

  onChange(mask, e) {
    e.target.value = VMasker.toPattern(e.target.value, mask)
    if (this.props.onChange)
      this.props.onChange(e);
  }

  render() {
    let props = {
        ...this.props,
        onChange: (e) => this.onChange(props.mask, e),
        value: this.props.value || ''
    }
    delete props.defaultValue; // remove default value from TextField input (see link below)
    return (<UI.TextField {...props} />);
  }
}

// Accessing PropTypes via the main React package is deprecated,
// and will be removed in  React v16.0. Use the latest available v15.* prop-types package from npm instead.
// For info on usage, compatibility, migration and more, see https://fb.me/prop-types-docs
//
// MaskedTextField.propTypes = {
//   mask: React.PropTypes.string
// };

export default MaskedTextField;


// WEBPACK FOOTER //
// ./registration-react/components/MaskedTextField.js